import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './ProjectsOnMap.css';

interface IProjectsOnMapProps {
  title: React.ReactNode;
  viewModeSwitch: React.ReactNode;
  map: React.ReactNode;
}

export function ProjectsOnMap({ title, viewModeSwitch, map }: IProjectsOnMapProps) {
  return (
    <section id="map" className={styles['project']}>
      <Layout>
        <div className={styles['project__top']}>
          {title}
          {viewModeSwitch}
        </div>

        {map}
      </Layout>
    </section>
  );
}
